import Link from 'next/link'
import { useTranslation } from 'react-i18next'
import { FCC } from '~/core/@types/global'
import { Button } from '~/core/ui/Button'
import { CircleCheckFill } from '~/core/ui/FillIcons'
import { cn } from '~/core/ui/utils'
import SectionContainer from './components/section/SectionContainer'
import {
  SOLUTIONS_ENTERPRISE_URL,
  SOLUTIONS_RECRUITMENT_AGENCY_URL
} from '~/core/constants/url'

const PLUS = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none">
    <line y1="6.5" x2="13" y2="6.5" stroke="#9CA3AF" />
    <line x1="6.5" y1="2.18557e-08" x2="6.5" y2="13" stroke="#9CA3AF" />
  </svg>
)

const SolutionsSection: FCC<{ className?: string }> = ({ className }) => {
  const { t, i18n } = useTranslation()

  const SECTIONS = [
    {
      contentTitle: t('lp:solutions_section:section_1_content_title'),
      contentDescription: t(
        'lp:solutions_section:section_1_content_description'
      ),
      contentBox: [
        t('lp:solutions_section:section_1_content_box_01'),
        t('lp:solutions_section:section_1_content_box_02'),
        t('lp:solutions_section:section_1_content_box_03'),
        t('lp:solutions_section:section_1_content_box_04')
      ],
      contentLink: SOLUTIONS_RECRUITMENT_AGENCY_URL
    },
    {
      contentTitle: t('lp:solutions_section:section_2_content_title'),
      contentDescription: t(
        'lp:solutions_section:section_2_content_description'
      ),
      contentBox: [
        t('lp:solutions_section:section_1_content_box_01'),
        t('lp:solutions_section:section_1_content_box_02'),
        t('lp:solutions_section:section_1_content_box_03')
      ],
      contentLink: SOLUTIONS_ENTERPRISE_URL
    }
  ]

  return (
    <SectionContainer
      title="lp:solutions_section:title"
      tagLabel="lp:solutions_section:tag"
      tagColor="bg-purple-100 text-purple-800"
      className={cn(className, 'pb-5 my-[44px] desktop:my-[120px]')}>
      <div className="relative">
        <div className="h-5 border-gray-100 border-r absolute -top-5 left-0 border-dashed" />
        <div className="w-5 border-gray-100 border-t absolute top-0 -left-5 border-dashed" />
        <div className="absolute -top-1.5 -left-1.5 z-10">{PLUS}</div>

        <div className="h-5 border-gray-100 border-r absolute -top-5 right-0 border-dashed" />
        <div className="w-5 border-gray-100 border-t absolute top-0 -right-5 border-dashed" />
        <div className="absolute -top-1.5 -right-1.5 z-10">{PLUS}</div>

        <div className="h-5 border-gray-100 border-r absolute -bottom-5 left-0 border-dashed" />
        <div className="w-5 border-gray-100 border-t absolute bottom-0 -left-5 border-dashed" />
        <div className="absolute -bottom-1.5 -left-1.5 z-10">{PLUS}</div>

        <div className="h-5 border-gray-100 border-r absolute -bottom-5 right-0 border-dashed" />
        <div className="w-5 border-gray-100 border-t absolute bottom-0 -right-5 border-dashed" />
        <div className="absolute -bottom-1.5 -right-1.5 z-10">{PLUS}</div>

        <div className="flex flex-col tablet:flex-row align-middle w-full justify-center mt-6 border-gray-100 border border-r-0">
          {SECTIONS.map((item, index) => (
            <div key={index} className="flex-1 border-gray-100 border-r">
              <div className="px-8 pb-8 pt-6 relative flex justify-between flex-col h-full">
                <div className="flex-1">
                  <span className="font-medium text-base uppercase text-white bg-gray-600 px-2 leading-6 rounded-sm absolute left-8 -top-6 mt-3">
                    {item.contentTitle}
                  </span>
                  <p className="font-normal text-base text-gray-700 mb-4">
                    {item.contentDescription}
                  </p>
                  <div className="h-px border-dashed border-t border-gray-100 w-full" />
                  <div className="space-y-3 mt-4">
                    {item.contentBox.map((box, index) => (
                      <div key={index} className="flex space-x-3 items-center">
                        <CircleCheckFill
                          className="!fill-green-500"
                          size={20}
                        />
                        <span className="text-base font-normal text-gray-900">
                          {box}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="mt-6 animate-fadeInUp">
                  <Link href={item.contentLink} locale={i18n?.language}>
                    <Button
                      type="secondary"
                      size="lg"
                      icon="trailing"
                      label={t('lp:view_solutions')}
                      iconMenus="ArrowUpRight"
                    />
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </SectionContainer>
  )
}

export default SolutionsSection
